import { ALL_PERMISSIONS } from '../lib/permissions'
import './NoAccess.css'

interface NoAccessProps {
  screen: string
  permission: string
  onBack: () => void
}

/**
 * Shown instead of a gated screen when the user lacks the permission.
 *
 * The old behaviour was to render a bare <TodayView /> with no props, so the
 * user was silently teleported back to a Today page where nothing worked and
 * nothing said why. Naming the permission also gives the admin something
 * specific to grant.
 */
export default function NoAccess({ screen, permission, onBack }: NoAccessProps) {
  const def = ALL_PERMISSIONS.find((p) => p.key === permission)

  return (
    <div className="noaccess" role="status">
      <div className="noaccess-lock" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
          <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
          <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
        </svg>
      </div>
      <h2>{screen} isn’t available on your account</h2>
      <p>
        This screen needs the <strong>{def?.name || permission}</strong> permission
        {def?.description ? ` — ${def.description.toLowerCase()}` : ''}.
      </p>
      <p className="noaccess-hint">
        Ask a super admin to grant it under <strong>Admin → Users &amp; Permissions</strong>.
      </p>
      <button className="noaccess-btn" onClick={onBack}>Back to Today</button>
    </div>
  )
}
